/**
 * Check user agent to decide if the user is a real person or a bot.
 * Only usable in client. Prefers truthy.
 *
 * @returns True if the user is a real person, false if a bot or crawler.
 */
export const isRealUser = (): boolean => !/bot|crawl|spider|headless/i.test(navigator.userAgent);
